import "moment-timezone";
import React, { Component } from "react";

import TrialCoachingSessionsService from "../utils/TrialCoachingSessionsService";

import { Field, Form, Formik } from "formik";
import Alert from "react-s-alert";
import * as Yup from "yup";

import FormikFormControl from "../Shared/Forms/FormikFormControl";
import FormikTextAreaControl from "../Shared/Forms/FormikTextAreaControl";

import moment from "moment-timezone";
import { Button, ControlLabel, Modal } from "react-bootstrap";
import { timezones } from "../utils/variables";

class ConfirmTCSModal extends Component {
  render() {
    const { showModal, onCloseModal, deal } = this.props;
    const validationSchema = Yup.object().shape({
      watched_webinar:
        deal.booking_from !== "seminar"
          ? Yup.string().required("must confirm Webinar was watched")
          : Yup.string(),
      parents_in_household: Yup.string().required("is required"),
      parents_attending_tcs: Yup.string().required("is required"),
      student_year_level: Yup.number().required("is required"),
      tech_device: Yup.string().required("is required"),
      parents_email: Yup.string()
        .required("is required")
        .max(100, "maximum 100 characters")
        .email("doesn't look like a valid email address"),
      notes_single_parent_attending: Yup.string()
        .max(2000, "maximum 2000 characters")
        .when(["parents_in_household", "parents_attending_tcs"], {
          is: (household, attending) =>
            household === "two" && attending === "one",
          then: schema =>
            schema.required("Please explain why only one parent is attending"),
          otherwise: schema => schema.notRequired()
        })
    });

    const initialValues = {
      parents_email: deal.lm_contact.email || "",
      parents_in_household: deal.tcs_parents_in_household || "",
      parents_attending_tcs: deal.tcs_parents_attending_tcs || "",
      student_year_level: deal.student_year_level || "",
      tech_device: deal.tcs_tech_device || "",
      watched_webinar: "",
      notes_single_parent_attending: deal.notes_single_parent_attending || ""
    };

    const region = deal.lm_contact.region || "VIC";
    const tcs_at_user = deal.tcs_at
      ? moment(deal.tcs_at)
          .tz(timezones[region])
          .format("dddd MMM Do YYYY h:mm a") +
        " in " +
        region
      : "n/a";

    return (
      <Modal show={showModal} onHide={onCloseModal} bsSize="large">
        <Modal.Header closeButton>
          <Modal.Title>Confirm TCS Attendance</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              const { onConfirmModal } = this.props;
              const { deal } = this.props;
              TrialCoachingSessionsService.takeAction(
                "mark_attendee_confirmed",
                deal.id,
                values
              ).then(response => {
                Alert.success("Confirmed attendee");
                onConfirmModal(response);
              });
            }}
            render={({ values, errors, touched, isValid, isSubmitting }) => {
              const showNotes =
                values.parents_in_household === "two" &&
                values.parents_attending_tcs === "one";
              return (
                <Form>
                  <h4 className="mt-0 mb-3">
                    Just need to confirm your appointment for {tcs_at_user}
                  </h4>
                  <div className="row">
                    <div className="col-sm-4">
                      <FormikFormControl
                        fieldName="student_year_level"
                        errors={errors}
                        touched={touched}
                      >
                        <ControlLabel>
                          What Year Level is{" "}
                          {deal.related_contacts[0].first_name.replace(
                            /\b\w/g,
                            char => char.toUpperCase()
                          )}{" "}
                          in?
                        </ControlLabel>
                        <Field
                          className="form-control input-sm"
                          name="student_year_level"
                          component="select"
                        >
                          <option value="">-- select --</option>
                          <option value="12">12</option>
                          <option value="11">11</option>
                          <option value="10">10</option>
                          <option value="9">9</option>
                          <option value="8">8</option>
                          <option value="7">7</option>
                        </Field>
                      </FormikFormControl>
                    </div>
                  </div>
                  {deal.booking_from !== "seminar" && (
                    <div>
                      <div className="row">
                        <div className="col-sm-4">
                          <FormikFormControl
                            fieldName="watched_webinar"
                            errors={errors}
                            touched={touched}
                          >
                            <ControlLabel>
                              Have you both watched the Webinar?
                            </ControlLabel>
                            <Field
                              className="form-control input-sm"
                              name="watched_webinar"
                              component="select"
                            >
                              <option value="">-- select --</option>
                              <option value="one">
                                Yes, they have watched it
                              </option>
                            </Field>
                          </FormikFormControl>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="row mb-2">
                    <div className="col-sm-4">
                      <FormikFormControl
                        fieldName="tech_device"
                        errors={errors}
                        touched={touched}
                      >
                        <ControlLabel>
                          It’s a zoom call so do you have a laptop or computer
                          with a camera?
                        </ControlLabel>
                        <Field
                          className="form-control input-sm"
                          name="tech_device"
                          component="select"
                        >
                          <option value="">-- select --</option>
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </Field>
                      </FormikFormControl>
                    </div>
                  </div>
                  <h4 className="mt-0">Is it a one or two parent household?</h4>
                  <div className="row mb-2">
                    <div className="col-sm-6">
                      <FormikFormControl
                        fieldName="parents_in_household"
                        errors={errors}
                        touched={touched}
                      >
                        <ControlLabel>Parents in the household?</ControlLabel>
                        <Field
                          className="form-control input-sm"
                          name="parents_in_household"
                          component="select"
                        >
                          <option value="">-- select --</option>
                          <option value="one">One</option>
                          <option value="two">Two</option>
                        </Field>
                      </FormikFormControl>
                    </div>
                    <div className="col-sm-6">
                      <FormikFormControl
                        fieldName="parents_attending_tcs"
                        errors={errors}
                        touched={touched}
                      >
                        <ControlLabel>Parents attending?</ControlLabel>
                        <Field
                          className="form-control input-sm"
                          name="parents_attending_tcs"
                          component="select"
                        >
                          <option value="">-- select --</option>
                          <option value="one">One</option>
                          <option value="two">Two</option>
                        </Field>
                      </FormikFormControl>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <FormikFormControl
                        fieldName="parents_email"
                        errors={errors}
                        touched={touched}
                      >
                        <ControlLabel>
                          We’ll send you an email an hour before the session so
                          just need to confirm your email….
                        </ControlLabel>
                        <Field
                          type="text"
                          name="parents_email"
                          className="form-control"
                        />
                      </FormikFormControl>
                    </div>
                  </div>
                  <div className="mb-2">
                    OK great, that's all confirmed, we look forward to seeing
                    you at <span className="bold">{tcs_at_user}</span>
                  </div>
                  <FormikTextAreaControl
                    fieldLabel="Quick Notes"
                    fieldName="notes_single_parent_attending"
                    errors={errors}
                    touched={touched}
                  />
                  <div className="mt-0">
                    <Button onClick={onCloseModal} bsSize="small">
                      Whoops, cancel this
                    </Button>
                    <Button
                      className="pull-right"
                      disabled={!isValid || isSubmitting}
                      type="submit"
                      bsStyle="success"
                      bsSize="small"
                    >
                      Confirm Attendance
                    </Button>
                  </div>
                </Form>
              );
            }}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

export default ConfirmTCSModal;
